import React from 'react';
import PropTypes from 'prop-types';
import 'd3';
import NVD3Chart from 'react-nvd3';
import get from 'lodash/get';
import Chart from '../../../components/Chart';

import {
  getTotalUndergraduateEnrollment,
  donutCallback,
  donutTooltip,
  formatValueAsPercent,
  formatDonutHalves,
} from '../../../utils/charts';

class Gender extends React.PureComponent {
  static props = {
    undergraduateEnrollment: PropTypes.object,
    isCamino: PropTypes.bool,
  };

  onRenderEnd = () => {
    const { undergraduateEnrollment } = this.props;

    const totalUndergraduateEnrollment = getTotalUndergraduateEnrollment(
      undergraduateEnrollment,
    ).toFixed(0);

    donutCallback('#gender-data-container', totalUndergraduateEnrollment, [
      'Total Undergrad',
      'Students',
    ]);
  };

  getGenderPercentageData = (undergraduateEnrollment) => {
    const genderPercData = [null, null];
    const menCount = Number(get(undergraduateEnrollment, 'men.value', '0') || '0');
    const womenCount = Number(get(undergraduateEnrollment, 'women.value', '0') || '0');

    let totalCount = 0;
    if (!Number.isNaN(menCount)) {
      totalCount += menCount;
    }
    if (!Number.isNaN(womenCount)) {
      totalCount += womenCount;
    }
    if (totalCount <= 0) return genderPercData;
    let menPerc = (menCount / totalCount) * 100;
    const womenPerc = (womenCount / totalCount) * 100;
    if (Math.round(menPerc) + Math.round(womenPerc) > 100) {
      // Example scenario -> menPerc = 44.5 (rounded 45) and womentPerc 55.5 (rounded 56)
      menPerc = Math.floor(menPerc);
    }

    if (!Number.isNaN(menCount)) {
      genderPercData[0] = Math.round(menPerc);
    }
    if (!Number.isNaN(womenCount)) {
      genderPercData[1] = Math.round(womenPerc);
    }

    return genderPercData;
  };

  render() {
    const { undergraduateEnrollment, isCamino } = this.props;
    const data = formatDonutHalves(
      this.getGenderPercentageData(undergraduateEnrollment),
      ['Male', 'Female'],
      isCamino,
    );

    return (
      <Chart data={data} title="Gender" id="gender-data-container">
        <NVD3Chart
          id="genderData"
          type="pieChart"
          datum={data}
          x="line1"
          y="value"
          margin={{ top: 0, left: 0, bottom: 0, right: 0 }}
          donut
          showLegend={false}
          labelType="value"
          donutRatio={0.5}
          showLabels
          showValues
          duration={250}
          labelThreshold={0.05}
          growOnHover
          renderEnd={this.onRenderEnd}
          valueFormat={formatValueAsPercent}
          tooltip={donutTooltip}
          padAngle={0.005}
        />
      </Chart>
    );
  }
}

export default Gender;
